import "./Footer.scss";

import { CONTACT_PHONES } from "../../Config";
import Logo from "../logo/Logo";
import React from "react";
import StringMethods from "../../utils/string/StringMethods";

interface Props {}
interface State {}

class Footer extends React.Component<Props, State> {
  public render() {
    return (
      <footer>
        <div className="content">
          <Logo />
          <div className="contacts">
            {CONTACT_PHONES.map((phoneNumber) => (
              <a href={`tel:375${phoneNumber}`} key={phoneNumber}>
                {StringMethods.beautifyPhoneNumber(phoneNumber)}
              </a>
            ))}
          </div>
          <div className="year">SMART © {new Date().getFullYear()}</div>
        </div>
      </footer>
    );
  }
}

export default Footer;
